// Example { birthdate : 'INVALID_DATE'}
export interface inputErrorsType {
  [id: string]: string;
}

export interface showInputErrorsType {
  [id: string]: boolean;
}

// Example { INVALID_DATE : 'Please enter a valid date'}
export interface errorMessageMappingType {
  [errorEnum: string]: string;
}

const errorMessageMapping = {
  // Date
  INVALID_DATE: `Please enter a valid date`,
  ALCOHOL_AGE_ERROR: `Recipient's birth date must be at least 21 to receive wine`,
  MAX_LENGTH_ADDRESS_ERROR: `Max 50 characters for Address Line 1 & 2. Use optional Attention field for names`,
  // Phone
  INVALID_PHONE: `Please enter a valid phone number`,

  // Email
  INVALID_EMAIL: `Please enter a valid email address`,

  // Address
  INVALID_STATE: `Please enter a valid state`,
  INVALID_ZIP: `Please enter a valid zip code`,
  POBOX_ERROR: `We cannot ship to PO Boxes`,
  INVALID_NUMBER: `Please enter a numeric quantity`,
  INVALID_POSITIVE_NUMBER: `Please enter a valid positive number`,

  // Generic
  REQUIRED_FIELD: `This field is required`,
  DEFAULT_ERROR: `There was a problem`,
  MIN_LENGTH_ERROR: `Please reach the minimum character requirement`,
  MAX_LENGTH_ERROR: `Character limit reached`,
  STRIPE_ERROR: `There was an error with your payment information. Please add your credit card again in the payment step and make sure to select that card.`,
};

// Get the display message for the error, and override any messages with a messageOverride dict.
export function getErrorMessage(
  errorEnum: string,
  messageOverride?: errorMessageMappingType,
): string {
  if (!errorEnum) return '';
  // Get the error message based on the error code.
  // If messageOverride is provided, choose the error message from there if it exists.
  if (messageOverride && messageOverride[errorEnum] !== undefined) {
    return messageOverride[errorEnum];
  }

  if (!errorMessageMapping[errorEnum]) {
    return errorMessageMapping.DEFAULT_ERROR;
  }
  return errorMessageMapping[errorEnum];
}
